// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TermsPage_body_3__h4eVo {
    color: #fff;
    background-color: #040404;
    font-size: 16px;
    line-height: 1.2;
  }

  .TermsPage_section_5__wGoDj {
    color: #fff;
    padding-top: 15vh;
    padding-bottom: 10vh;
  }

.TermsPage_div_block_54__ohCq1 {
    grid-column-gap: 1vw;
    grid-row-gap: 1vw;
    flex-flow: column;
    display: flex;
  }

  .TermsPage_text_block_32__JoxA1 {
    font-size: 2rem;
  }
  .TermsPage_text_block_33__VH360 {
    color: #fff;
    font-size: 1vw;
}

.TermsPage_link_4__FxfkJ {
  color: #0094ff;
}

.TermsPage_list__XD\\+qY {
  grid-column-gap: 1vw;
  grid-row-gap: 1vw;
  flex-flow: column;
  margin-top: 0;
  margin-bottom: 0;
  display: flex;
}

.TermsPage_text_block_33__VH360, .TermsPage_list_item_4__DBNoj, .TermsPage_list_item_5__qrdDL, .TermsPage_list_item_6__CcKsI {
    font-size: 1rem;
}

.TermsPage_div_block_51__BUUtK {
    grid-column-gap: 2.2vw;
    grid-row-gap: 2.2vw;
    flex-flow: column;
    justify-content: flex-start;
    align-items: flex-start;
    display: flex;
}

.TermsPage_div_block_52__u-Uep {
    grid-column-gap: 2vw;
    grid-row-gap: 2vw;
    flex-flow: column;
    width: auto;
    display: flex;
}

.TermsPage_div_block_51__BUUtK, .TermsPage_div_block_52__u-Uep {
    grid-column-gap: 2rem;
    grid-row-gap: 2rem;
}

.TermsPage_heading_15__eXTFh {
    color: #fff;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 12vw;
    font-weight: 900;
    line-height: 1;
}
@media screen and (max-width: 479px) {
  .TermsPage_heading_15__eXTFh {
      font-size: 5rem;
  }
  }

.TermsPage_section_6__lXP0U {
    padding-top: 15vh;
    padding-bottom: 10vh;
}

.TermsPage_text_block_35__SJRgh {
    font-size: 16px;
    font-weight: 500;
}

.TermsPage_heading_16__s6H5M {
    color: #fff;
    text-align: left;
    margin-top: 0;
    margin-bottom: 16px;
    font-size: 4.4vw;
    line-height: 1.2;
}

.TermsPage_heading_16__s6H5M {
    font-size: 3rem;
}


  .TermsPage_text_block_34__ccmHT {
    color: silver;
    font-size: 1vw;
  }

  .TermsPage_text_block_34__ccmHT {
    font-size: 1rem;
  }

  .TermsPage_text_block_30__XwpSu {
    color: #fff;
    text-align: left;
    font-size: 1vw;
  }
  .TermsPage_text_block_30__XwpSu {
    font-size: 1rem;
  }

  .TermsPage_text_block_32__JoxA1 {
    color: #fff;
    font-size: 2vw;
    font-weight: 600;
  }

  .TermsPage_text_block_32__JoxA1 {
    font-size: 2rem;
  }

  .TermsPage_w_layout_blockcontainer__aowjz {
    max-width: 940px;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
  
  @media screen and (max-width: 991px) {
    .TermsPage_w_layout_blockcontainer__aowjz {
      max-width: 728px;
    }
  }
  
  @media screen and (max-width: 767px) {
    .TermsPage_w_layout_blockcontainer__aowjz {
      max-width: none;
    }
  }

  .TermsPage_w_container__cepo3 {
    margin-left: auto;
    margin-right: auto;
    max-width: 940px;
  }
  .TermsPage_w_container__cepo3:before,
  .TermsPage_w_container__cepo3:after {
    content: " ";
    display: table;
    grid-column-start: 1;
    grid-row-start: 1;
    grid-column-end: 2;
    grid-row-end: 2;
  }
  .TermsPage_w_container__cepo3:after {
    clear: both;
  }
  .TermsPage_w_container__cepo3 .TermsPage_w_row__KWOvv {
    margin-left: -10px;
    margin-right: -10px;
  }

  @media screen and (max-width: 991px) {
    .TermsPage_w_container__cepo3 {
      max-width: 728px;
    }
    .TermsPage_w_container__cepo3 .TermsPage_w_row__KWOvv {
        margin-left: 0;
        margin-right: 0;
      }
}
@media screen and (max-width: 479px) {
    .TermsPage_w_container__cepo3 {
      max-width: none;
    }
}

.TermsPage_container_14__gSlLt {
  width: 100%;
  max-width: 80vw;
  padding-left: 3.3vw;
  padding-right: 3.3vw;
}`, "",{"version":3,"sources":["webpack://./src/pages/UtilityPages/Terms/TermsPage.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,oBAAoB;EACtB;;AAEF;IACI,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,cAAc;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;IAC3B,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;EACE;MACI,eAAe;EACnB;EACA;;AAEF;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;;EAGE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,eAAe;IACjB;EACF;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;;IAEE,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE;MACE,gBAAgB;IAClB;IACA;QACI,cAAc;QACd,eAAe;MACjB;AACN;AACA;IACI;MACE,eAAe;IACjB;AACJ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB","sourcesContent":[".body_3 {\n    color: #fff;\n    background-color: #040404;\n    font-size: 16px;\n    line-height: 1.2;\n  }\n\n  .section_5 {\n    color: #fff;\n    padding-top: 15vh;\n    padding-bottom: 10vh;\n  }\n\n.div_block_54 {\n    grid-column-gap: 1vw;\n    grid-row-gap: 1vw;\n    flex-flow: column;\n    display: flex;\n  }\n\n  .text_block_32 {\n    font-size: 2rem;\n  }\n  .text_block_33 {\n    color: #fff;\n    font-size: 1vw;\n}\n\n.link_4 {\n  color: #0094ff;\n}\n\n.list {\n  grid-column-gap: 1vw;\n  grid-row-gap: 1vw;\n  flex-flow: column;\n  margin-top: 0;\n  margin-bottom: 0;\n  display: flex;\n}\n\n.text_block_33, .list_item_4, .list_item_5, .list_item_6 {\n    font-size: 1rem;\n}\n\n.div_block_51 {\n    grid-column-gap: 2.2vw;\n    grid-row-gap: 2.2vw;\n    flex-flow: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    display: flex;\n}\n\n.div_block_52 {\n    grid-column-gap: 2vw;\n    grid-row-gap: 2vw;\n    flex-flow: column;\n    width: auto;\n    display: flex;\n}\n\n.div_block_51, .div_block_52 {\n    grid-column-gap: 2rem;\n    grid-row-gap: 2rem;\n}\n\n.heading_15 {\n    color: #fff;\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 12vw;\n    font-weight: 900;\n    line-height: 1;\n}\n@media screen and (max-width: 479px) {\n  .heading_15 {\n      font-size: 5rem;\n  }\n  }\n\n.section_6 {\n    padding-top: 15vh;\n    padding-bottom: 10vh;\n}\n\n.text_block_35 {\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.heading_16 {\n    color: #fff;\n    text-align: left;\n    margin-top: 0;\n    margin-bottom: 16px;\n    font-size: 4.4vw;\n    line-height: 1.2;\n}\n\n.heading_16 {\n    font-size: 3rem;\n}\n\n\n  .text_block_34 {\n    color: silver;\n    font-size: 1vw;\n  }\n\n  .text_block_34 {\n    font-size: 1rem;\n  }\n\n  .text_block_30 {\n    color: #fff;\n    text-align: left;\n    font-size: 1vw;\n  }\n  .text_block_30 {\n    font-size: 1rem;\n  }\n\n  .text_block_32 {\n    color: #fff;\n    font-size: 2vw;\n    font-weight: 600;\n  }\n\n  .text_block_32 {\n    font-size: 2rem;\n  }\n\n  .w_layout_blockcontainer {\n    max-width: 940px;\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n  }\n  \n  @media screen and (max-width: 991px) {\n    .w_layout_blockcontainer {\n      max-width: 728px;\n    }\n  }\n  \n  @media screen and (max-width: 767px) {\n    .w_layout_blockcontainer {\n      max-width: none;\n    }\n  }\n\n  .w_container {\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 940px;\n  }\n  .w_container:before,\n  .w_container:after {\n    content: \" \";\n    display: table;\n    grid-column-start: 1;\n    grid-row-start: 1;\n    grid-column-end: 2;\n    grid-row-end: 2;\n  }\n  .w_container:after {\n    clear: both;\n  }\n  .w_container .w_row {\n    margin-left: -10px;\n    margin-right: -10px;\n  }\n\n  @media screen and (max-width: 991px) {\n    .w_container {\n      max-width: 728px;\n    }\n    .w_container .w_row {\n        margin-left: 0;\n        margin-right: 0;\n      }\n}\n@media screen and (max-width: 479px) {\n    .w_container {\n      max-width: none;\n    }\n}\n\n.container_14 {\n  width: 100%;\n  max-width: 80vw;\n  padding-left: 3.3vw;\n  padding-right: 3.3vw;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body_3": `TermsPage_body_3__h4eVo`,
	"section_5": `TermsPage_section_5__wGoDj`,
	"div_block_54": `TermsPage_div_block_54__ohCq1`,
	"text_block_32": `TermsPage_text_block_32__JoxA1`,
	"text_block_33": `TermsPage_text_block_33__VH360`,
	"link_4": `TermsPage_link_4__FxfkJ`,
	"list": `TermsPage_list__XD+qY`,
	"list_item_4": `TermsPage_list_item_4__DBNoj`,
	"list_item_5": `TermsPage_list_item_5__qrdDL`,
	"list_item_6": `TermsPage_list_item_6__CcKsI`,
	"div_block_51": `TermsPage_div_block_51__BUUtK`,
	"div_block_52": `TermsPage_div_block_52__u-Uep`,
	"heading_15": `TermsPage_heading_15__eXTFh`,
	"section_6": `TermsPage_section_6__lXP0U`,
	"text_block_35": `TermsPage_text_block_35__SJRgh`,
	"heading_16": `TermsPage_heading_16__s6H5M`,
	"text_block_34": `TermsPage_text_block_34__ccmHT`,
	"text_block_30": `TermsPage_text_block_30__XwpSu`,
	"w_layout_blockcontainer": `TermsPage_w_layout_blockcontainer__aowjz`,
	"w_container": `TermsPage_w_container__cepo3`,
	"w_row": `TermsPage_w_row__KWOvv`,
	"container_14": `TermsPage_container_14__gSlLt`
};
export default ___CSS_LOADER_EXPORT___;
